import React, { useEffect, useState, useRef } from "react";
import { Container, Stack, FormControl, Button } from "react-bootstrap";
import { ReactComponent as SendIcon } from "../assets/send-icon.svg";
import axios from 'axios'
import '../styles/csvagent.css'

const CSVAgent = () => {
    document.title= "CSV Agent"
    const [question, setQuestion] = useState("");
    const [chat,setChat] = useState([])
    const [key, setKey] = useState("");
    const [file, setFile] = useState(null);
    const [keyAdded, setKeyAdded] = useState(false);
    const [fileAdded, setFileAdded] = useState(false);
    const [loading, setLoading] = useState(false);
    const loadRef = useRef(null)
    loadRef.current = loading
    const chatRef = useRef(null)
    chatRef.current = chat

    const saveKey = () => {
        localStorage.setItem("openaikey", key);
        setKeyAdded(true);
    }

    let askCSV = () => {
        setChat([...chatRef.current,{isBot:false,msg:question}])
        setLoading((prev)=>true)
        let getQuestion = question
        setQuestion("")
        axios.post("/ask_csv", {file:file,question:getQuestion,key:key}, {
            headers: {
            'Content-Type': 'multipart/form-data'
            }
        }).then((res)=>{
            setLoading((prev)=>false)

            setChat([...chatRef.current,{isBot:true,msg:res.data}])

          }).catch((err)=>{
            console.log("Error in CSV");
        })
    }


    useEffect(() => {
        if (localStorage.getItem("openaikey") !== null && localStorage.getItem("openaikey") !== undefined) {
            setKey(localStorage.getItem("openaikey"));
            setKeyAdded(true);
        }
    },[])

    useEffect(() => {
        if (document.querySelector(".end-chat") != null) {
          document
            .querySelector(".end-chat")
            .scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }, [chat]);
    return (
        <div className="csv-agent-bg vh-100  p-md-5">
            <div className="csv-agent-container text-light h-100 p-3 p-md-5">
                <div class="d-flex justify-content-between">
                    <div class="d-flex flex-column">
                        <h1>// CSV<i>Agent</i></h1>
                        <span>---  Chat with your CSV file  ---</span>
                    </div>
                    <div class="d-flex flex-column text-end">
                        {fileAdded&&<div style={{cursor:'pointer'}} className="fw-bold" onClick={()=>setFileAdded(false)}>[ {file.name} ]</div>}
                        <small style={{cursor:'pointer'}} className="fw-bold" onClick={()=>setKeyAdded(false)}>Change Key</small>
                    </div>
                </div>
                {keyAdded===false?
                    <Stack gap={3} className="my-5">
                        <h4 className="m-0">{'>'} Add your OpenAI Key</h4>
                        <div class="d-flex align-items-center justify-content-between gap-4 csv-agent-key">
                            <FormControl onChange={(e) => setKey(e.target.value)} className="helper-input csv-input" onKeyDown={(e) => {
                            e.code == "Enter" && !e.shiftKey && saveKey();
                        }}/>

                            <SendIcon onClick={saveKey} style={{cursor:"pointer",color:key===""?"#EEE5E9":"#736CED"}} className="mygpt-icon" />
                        </div>
                        <p className="m-0"><small>Get your OpenAI Key by signing up/ logging in from the OpenAI Dashboard. </small><a target="_blank" href="https://platform.openai.com/account/api-keys">Go to Dashboard</a></p>
                        <small>--- Watch this video to get started ---</small>
                        <iframe className="csv-agent-video " src="https://www.youtube.com/embed/FaJdwbNWNkk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                    </Stack>:
                    <>
                        {fileAdded===false?
                        <Stack gap={3} className="my-5">
                            <h4 className="m-0">{'>'} Add your CSV file</h4>
                            <div class="d-flex align-items-center justify-content-between gap-4 csv-agent-key">
                                <FormControl className="helper-input csv-input" type="file" accept=".csv" onChange={(e) => setFile(e.target.files[0])}/>

                                <SendIcon onClick={()=>setFileAdded(true)} style={{cursor:"pointer",color:key===""?"#EEE5E9":"#736CED"}} className="mygpt-icon" />
                            </div>
                        </Stack>:
                        <Stack gap={3} style={{height:'85%'}} className="pt-5">
                            <Stack className="h-100 csv-agent-scroll" gap={3}>
                                <div className="px-3 py-2 helper-msg csv-msg align-self-start">
                                    Hi!
                                </div>
                                <div className="px-3 py-2 helper-msg csv-msg align-self-start">
                                    I'm {file.name}, ask me anything!
                                </div>
                                {chatRef.current.length>0&&chatRef.current.map((message)=>
                                    <div className={message.isBot?"px-3 py-2 helper-msg csv-msg align-self-start":"px-3 py-2 csv-user-msg align-self-end"}>
                                        {message.msg}
                                    </div>
                                )}
                                {loadRef.current&&<small className="csv-agent-loading">Thinking </small>}
                                <div className="end-chat"></div>

                            </Stack>
                            <div class="mt-auto d-flex align-items-center justify-content-between gap-4">
                                <FormControl value={question} onChange={(e) => setQuestion(e.target.value)} className="helper-input csv-input" onKeyDown={(e) => {
                                e.code == "Enter" && !e.shiftKey && askCSV();
                                }}/>
                                <SendIcon onClick={askCSV} style={{cursor:"pointer",color:question===""?"#EEE5E9":"#736CED"}} className="mygpt-icon" />
                            </div>
                        </Stack>
                        }
                    </>
                
                }
                
            </div>
        </div>
    );
};

export default CSVAgent;
